export default {
  title: 'Куда поехать и что посмотреть',
} as const;
